import { combineEpics } from 'redux-observable';

import fetchBankCodesEpic from './fetchBankCodes.epic';

export default combineEpics(fetchBankCodesEpic);
